import { render, staticRenderFns } from "./global-modal-error.vue?vue&type=template&id=8716042a&scoped=true"
import script from "./global-modal-error.vue?vue&type=script&lang=ts"
export * from "./global-modal-error.vue?vue&type=script&lang=ts"
import style0 from "./global-modal-error.vue?vue&type=style&index=0&id=8716042a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8716042a",
  null
  
)

export default component.exports